// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectLayout_root__-FyAK","app":"ProjectLayout_app__19Klf","main":"ProjectLayout_main__2UIEB","drawer":"ProjectLayout_drawer__13q6l"};